// extracted by mini-css-extract-plugin
export default {"container":"Section1_container__Zzgcj","videoBox":"Section1_videoBox__zcahX","heroVideo":"Section1_heroVideo__6b0Ae","dimmed":"Section1_dimmed__am-Z5","logo":"Section1_logo__xsGdW"};